import Navbar from '../components/landing/Navbar';
import HeroSection from '../components/landing/HeroSection';
import FeaturesSection from '../components/landing/FeaturesSection';
import HowItWorksSection from '../components/landing/HowItWorksSection';
import WhatsappSection from '../components/landing/WhatsappSection';
import TestimonialsSection from '../components/landing/TestimonialsSection';
import ExpertSection from '../components/landing/ExpertSection';
import PricingSection from '../components/landing/PricingSection';
import FaqSection from '../components/landing/FaqSection';
import CTASection from '../components/landing/CTASection';
import Footer from '../components/landing/Footer';

export default function LandingPage() {
  return (
    <div className="relative bg-background text-foreground overflow-x-hidden" data-testid="landing-page">
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <HowItWorksSection />
        <WhatsappSection />
        <TestimonialsSection />
        <ExpertSection />
        <PricingSection />
        <FaqSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
